import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { SettingsPharmacyService } from './service';
import * as actionsNotification from '../InitComponent/actions';
import {
  NOTIFICATION_CHANGES_SAVED,
  NOTIFICATION_CHANGES_NOT_SAVED,
  NOTIFICATION_CHANGES_NOT_SAVED_GLOVO_TIME,
  NOTIFICATION_CHANGES_NOT_SAVED_GLOVO_GLOBAL,
} from '../../global/constants';

interface GlovoEnableSource {
  type: string;
  payload: { sourceCode: string; until: string; postEffect: any };
}

interface GlovoEnableResponse {
  enabled: boolean | null;
  status: string;
}

export function* getGlovoEnabledStatusSaga({ payload }: GlovoEnableSource) {
  try {
    const response: GlovoEnableResponse = yield call(
      SettingsPharmacyService.getGlovoEnabledStatus,
      payload.sourceCode
    );
    yield put(actions.getGlovoPharmacyStatus.success(response));
  } catch (error) {
    yield put(actions.getGlovoPharmacyStatus.error(error));
  }
}

export function* setEnambleGlovoPharmacySaga({ payload }: GlovoEnableSource) {
  try {
    const response: { status: string } = yield call(
      SettingsPharmacyService.setEnambleGlovo,
      payload.sourceCode
    );

    yield put(
      actionsNotification.addApplicationNotification({
        content: 'Глово в аптеке включен!',
        canBeClosed: true,
        type: 'success',
      })
    );

    if (payload.postEffect) {
      payload.postEffect();
    }
    yield put(actions.setEnableGlovoPharmacy.success(response.status));
  } catch (error) {
    yield put(
      actionsNotification.addApplicationNotification({
        content:
          (error as any).response.data.message ===
          "can't open pharmacy, because global closure happened"
            ? NOTIFICATION_CHANGES_NOT_SAVED_GLOVO_GLOBAL
            : NOTIFICATION_CHANGES_NOT_SAVED,
        canBeClosed: true,
        type: 'error',
      })
    );

    yield put(actions.setEnableGlovoPharmacy.error(error));
  }
}

export function* setDisableGlovoPharmacySaga({ payload }: GlovoEnableSource) {
  try {
    const response: { result: string } = yield call(
      SettingsPharmacyService.setDisableGlovo,
      payload.sourceCode,
      payload.until
    );

    yield put(
      actionsNotification.addApplicationNotification({
        content: `Глово в аптеке выключен до ${new Date(
          payload.until
        ).toLocaleString()}!`,
        canBeClosed: true,
        type: 'success',
      })
    );

    if (payload.postEffect) {
      payload.postEffect();
    }
    yield put(actions.setDisableGlovoPharmacy.success(response.result));
  } catch (error) {
    yield put(
      actionsNotification.addApplicationNotification({
        content:
          (error as any).response.data.message ===
          'until time must be in the future'
            ? NOTIFICATION_CHANGES_NOT_SAVED_GLOVO_TIME
            : NOTIFICATION_CHANGES_NOT_SAVED,
        canBeClosed: true,
        type: 'error',
      })
    );

    yield put(actions.setDisableGlovoPharmacy.error(error));
  }
}

export function* settingPagePharmacyWatcherSaga() {
  yield all([
    takeLatest(
      actions.getGlovoPharmacyStatus.REQUEST,
      getGlovoEnabledStatusSaga
    ),
  ]);
  yield all([
    takeLatest(
      actions.setEnableGlovoPharmacy.REQUEST,
      setEnambleGlovoPharmacySaga
    ),
  ]);
  yield all([
    takeLatest(
      actions.setDisableGlovoPharmacy.REQUEST,
      setDisableGlovoPharmacySaga
    ),
  ]);
}
